import * as d3 from "d3";

async function BarChartVisual(el, data, config) {

    let maxY = 0;
    const propNameX = config[0];
    const propNameY = config[1];
    const dataSet = data.map((datum) => {
        if (datum[propNameY] && parseInt(datum[propNameY].value) > maxY) {
            maxY = parseInt(datum[propNameY].value);
        }
        return {
            x: datum[propNameX] ? datum[propNameX].value : undefined,
            y: datum[propNameY] ? datum[propNameY].value : undefined
        };
    });
    const xDataset = dataSet.map(datum => datum.x);

    let svg = d3.select(el);
    const width = el.getBoundingClientRect().width - 70;
    const height = el.getBoundingClientRect().height - 50;

    const xScale = d3.scaleBand().rangeRound([0, width]).padding(0.5);
    const yScale = d3.scaleLinear().rangeRound([height, 0]);

    var g = svg.append("g").attr("transform", "translate(60,10)");

    xScale.domain(xDataset);
    yScale.domain([0, maxY]);

    g.append("g")
        .attr("transform", "translate(0," + height + ")")
        .attr('style', "font-size: 14px; color: #13294B; font-family: 'roboto'")
        .call(d3.axisBottom(xScale).tickFormat(function (d) {
            return d;
        }));

    g.append("g")
        .attr('style', "font-size: 14px; color: #13294B; font-family: 'roboto'")
        .call(d3.axisLeft(yScale).tickFormat(function (d) {
            if (d === parseInt(d)) return d;
            return "";
        }));

    g.selectAll(".bar")
        .data(dataSet)
        .enter()
        .append("rect")
        .attr("class", "bar")
        .attr("x", function (d) { return xScale(d.x); })
        .attr("y", function (d) { return yScale(d.y); })
        .attr('stroke','#84BC01')
        .attr('fill', '#84BC01')
        .attr("width", xScale.bandwidth())
        .attr("height", function (d) { return height - yScale(d.y); });

}

export default BarChartVisual;